import type { Configuration, SalesChannel } from '@vista-digital/lumos-cms-client'
import { getSalesChannelConfiguration } from './get-sales-channel-configuration'

export const getConfiguration = (): Configuration<SalesChannel.Web> | undefined => {
    return getSalesChannelConfiguration()?.configuration
}
